
class HTMLElementPlus extends HTMLElement {
  constructor() {
    super()
  }

  attributeToProperty(name) {
    return name.replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) => idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()).replace(/[\s\-]+/g, '')
  }

  propertyToAttribute(name) {
    return name.replace(/([A-Z])/g, (m) => "-" + m[0].toLowerCase())
  }

  connectedCallback() {
    let observedAttributes = []

    // get list of properties with "Changed" handlers and their attribute names
    for(let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if(name.endsWith("Changed")) {
        let propertyName = name.substring(0, name.length - 7)
        let attributeName = this.propertyToAttribute(propertyName)
        this[propertyName] = this.getAttribute(attributeName)
        observedAttributes.push(attributeName)
      }
    }

    // setup an observer for the monitored attributes
    new MutationObserver((mutations) => {
      for(let mutation of mutations) {
        let attributeName = mutation.attributeName
        let propertyName = this.attributeToProperty(attributeName)
        this[propertyName] = this.getAttribute(attributeName)
        if(propertyName + "Changed" in this) {
          this[propertyName + "Changed"](mutation.target.getAttribute(attributeName))
        }
      }
      if(typeof this.update == "function") {this.update()}
    }).observe(this, {attributes: true, attributeFilter: observedAttributes})

    if(typeof this.init == "function") {this.init()}
    if(typeof this.update == "function") {this.update()}
  }
}

class StarRating extends HTMLElementPlus {
  init() {
    $(this).html(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292 55" xml:space="preserve">
        <defs><clipPath id="rating_clip" clipPathUnits="objectBoundingBox"><rect x="0" y="0" height="1" width="0" /></clipPath></defs>
        <g id="stars" fill="var(--yellow)" opacity="0.25" ><path d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3z" /></g>
        <g id="stars" fill="var(--yellow)" clip-path="url(#rating_clip)"><path d="m27 1 8 17 19 3-14 13 4 19-17-9-17 9 3-19L0 21l19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3zm60 0 8 17 19 3-14 13 4 19-17-9-17 9 3-19-13-13 19-3z" /></g>
      </svg>
      <span></span>
      `)
  }

  ratingChanged() {}
  rating_countChanged() {}

  update() {
    if(!this.rating) return
    let scaledRating = (Math.round(2 * parseFloat(this.rating)) / 2) / 5.0
    if(isNaN(scaledRating)) return
    $(this).find("svg clipPath rect").attr("width", scaledRating)
    if(this.rating_count == null || this.rating_count == 0) {
      $(this).find("span").text("no reviews yet")
      $(this).attr("title", "no reviews yet")
    } else {
      // "(150)" by default, "150 reviews" with the verbose attribute
      let reviews = `${ this.rating_count } review${ this.rating_count > 1 ? "s": "" }`
      $(this).find("span").text(this.hasAttribute("verbose") ? reviews : `(${ this.rating_count })`)
      $(this).attr("title", reviews)
    }
  }
}
customElements.define("star-rating", StarRating)


/*
  what is paid for one of something: amounts are ex VAT, and the market's VAT
  is added for taxable items, rounded to the currency's minor unit so that a
  quantity of them adds up to exactly the unit price shown times the quantity
*/
paidAmount = (amount, taxable) => {
  let vat = String(taxable) == "true" ? (window.market?.vat || 0) : 0
  let scale = Math.pow(10, window.currency?.decimalPlaces ?? 2)
  return Math.round(amount * (1 + vat) * scale) / scale
}

/* format an ex VAT amount in the visitor's market currency as the price paid for `quantity` of it */
formatMoney = (amount, taxable, quantity = 1) => {
  let currency = window.currency
  if(!currency) {
    return ""
  }
  let formatted = (paidAmount(amount, taxable) * quantity).toLocaleString(currency.locale, {minimumFractionDigits: currency.decimalPlaces, maximumFractionDigits: currency.decimalPlaces})
  return currency.symbol + formatted
}

class CurrencyMoney extends HTMLElementPlus {
  constructor() {
    super()
  }

  init() {
    $(window).on("currencychanged", (e, v) => {
      this.update()
    })
  }

  formatMoney(amount, taxable) {
    return formatMoney(amount, taxable)
  }

  amountChanged() {}

  update() {
    if(!this.amount) return
    $(this).html(this.formatMoney(this.amount))
  }
}
customElements.define("currency-money", CurrencyMoney )

class ProductPrice extends HTMLElementPlus {
  constructor() {
    super()
  }

  /*
    price, compare_at_price and taxable can be given as attributes, or as a list
    of <product-variant> children with a `selected` attribute naming the variant
    id to show; with no selection the first variant is shown. the component is
    upgraded before its children are parsed, so it watches for them arriving.
  */
  init() {
    $(this).append(`<div></div><small></small>`)

    new MutationObserver((mutations) => {
      let variantAdded = mutations.some(m => [...m.addedNodes].some(n => n.nodeName == "PRODUCT-VARIANT"))
      if(variantAdded) this.update()
    }).observe(this, {childList: true, subtree: true})

    $(window).on("currencychanged", (e, v) => {
      this.update()
    })
  }

  formatMoney(amount, taxable, quantity) {
    return formatMoney(amount, taxable, quantity)
  }

  quantityChanged() {}
  priceChanged() {}
  compare_at_priceChanged() {}
  taxableChanged() {}
  selectedChanged() {}

  /* the offer to show: the selected (or first) child variant, else our own attributes */
  offer() {
    // <product-variant /> does not self close in HTML, so later variants nest inside earlier ones
    let variants = $(this).find("product-variant")
    if(variants.length == 0) {
      return {price: this.price, compare_at_price: this.compare_at_price, taxable: this.taxable}
    }
    let variant = this.selected ? variants.filter(`[id="${this.selected}"]`) : $()
    variant = (variant.length ? variant : variants).first()
    return {price: variant.attr("price"), compare_at_price: variant.attr("compare_at_price"), taxable: variant.attr("taxable")}
  }

  update() {
    let offer = this.offer()
    let quantity = this.quantity || 1
    let price = parseFloat(offer.price) || 0
    let compare = parseFloat(offer.compare_at_price) || 0
    $(this).children("div").html(this.formatMoney(price, offer.taxable, quantity))
    $(this).children("small").html(compare > price ? `(was ${ this.formatMoney(compare, offer.taxable, quantity) })` : "")
  }
}
customElements.define("product-price", ProductPrice)

class ProductBadge extends HTMLElementPlus {
  constructor() {
    super()
  }

  init() {
    $(this).html(``)
  }

  discountChanged() {}

  // one label per tile: how it can be bought comes before how it is promoted
  update() {
    let labels = [["_retired", "Retired"], ["_preorder", "Pre-order"], ["_outofstock", "Out of stock"], ["_discounted", `${this.discount}% off!`], ["_new", "New"], ["_popular", "Popular"]]
    let label = labels.find(([name]) => $(this).hasClass(name))
    if(label) {
      $(this).html(label[1]).show()
      return
    }
    $(this).hide()
  }
}
customElements.define("product-badge", ProductBadge)

/*
  arrow buttons for a .strip: a click scrolls one card's width, and each button
  hides at its own end of the strip. Pass the .strip-band element that holds
  the strip and its .step.back and .step.forward buttons.
*/
stepStrip = (band) => {
  let strip = band.querySelector(".strip")
  let back = band.querySelector(".step.back")
  let forward = band.querySelector(".step.forward")
  const step = () => (strip.children[1] || strip.children[0])?.getBoundingClientRect().width + 16 || 300
  const update = () => {
    back.hidden = strip.scrollLeft < 10
    forward.hidden = strip.scrollLeft + strip.clientWidth > strip.scrollWidth - 10
  }
  back.addEventListener("click", () => strip.scrollBy({left: -step(), behavior: "smooth"}))
  forward.addEventListener("click", () => strip.scrollBy({left: step(), behavior: "smooth"}))
  strip.addEventListener("scroll", update, {passive: true})
  new ResizeObserver(update).observe(strip)
  new MutationObserver(update).observe(strip, {childList: true})
  update()
}
